import { render, staticRenderFns } from "./copy.vue?vue&type=template&id=389c2043"
import script from "./copy.vue?vue&type=script&lang=js"
export * from "./copy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('389c2043')) {
      api.createRecord('389c2043', component.options)
    } else {
      api.reload('389c2043', component.options)
    }
    module.hot.accept("./copy.vue?vue&type=template&id=389c2043", function () {
      api.rerender('389c2043', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/purchase/apply/copy.vue"
export default component.exports